import React from "react";
import 'font-awesome/css/font-awesome.min.css'
import {FaLinkedin, FaGithub, FaInstagram, FaHome, FaEnvelope, FaPhone } from 'react-icons/fa';
export default function Footer(){
    return(
        
<footer className="text-center text-lg-start bg-light text-muted mw-100 ">
  
  <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
    
    <div className="me-5 d-none d-lg-block">
      <span>Get connected with me on social networks:</span>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/sanskar-garodia-879753170" className="me-4 text-reset">
        <FaLinkedin/>
      </a>
      <a href="https://github.com/sanskargarodia" className="me-4 text-reset">
        <FaGithub/> 
      </a>
      <a href="https://www.instagram.com/" className="me-4 text-reset">
        <FaInstagram/>  
      </a>
    </div>
    
  </section>
  
  <section className="section">
    <div className="container text-center text-md-start mt-5">
      
      <div className="row mt-3">
       
        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
         
          <h6 className="text-uppercase fw-bold mb-4">
            Major Projects
          </h6>
          <p>
            <a href="/projects" className="text-reset">Friend In Need</a>
          </p>
          <p>
            <a href="/projects" className="text-reset">FaceSham</a>
          </p>
          <p>
            <a href="/projects" className="text-reset">StockPred</a>
          </p>
        </div>
      
       
        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
          
          <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
          <p><FaHome/> 1359 1/2 W Adams Blvd, LA, USA</p>
          <p>
            <FaEnvelope/> sanskargarodia05@gmail.com
          </p>
          <p><FaPhone/> +1 (213) 675 1503</p>
        </div>
       
      </div>
      
    </div>
  </section>
 
  <div className="text-center p-4" style={{backgroundColor: "rgba(0, 0, 0, 0.05)"}}>
    Developed By:
    Sanskar Garodia
  </div>
 
</footer>
    )

}